<template>
	<div>
		<h3>这是父组件</h3>
		<Son>
			<template slot="myslot" slot-scope="scope">
				<ul>
					<li v-for="item in scope.data">{{item}}</li>
				</ul>
			</template>
		</Son>
		<!-- <div ref="playerRef" style="width: 1000px;height: 800px;"></div> -->
	</div>
</template>

<script>
	import flvjs from 'flv.js'
	import Son from '../demo/son.vue'
	import {
		QNRTPlayer
	} from "qn-rtplayer-web";

	export default {
		components: {
			Son
		},
		data() {
			return {
				playerRtc: null,
				url: "webrtc://qvs-live.thirdmonitor.concoai.com:447/2xenzwqy2ppcl/31011500991180026440_34020000001320000001"
			}
		},
		props: [],
		mounted() {
			let that = this
			if (that.$refs.playerRef) {
				that.playerRtc = new QNRTPlayer();
				// 监听
				that.playerRtc.on('playerStateChanged', state => {
					if (state == 3) {
						that.playerRtc.pause()
					}
				});
				that.playerRtc.init({
					volumn: null,
					controls: false
				});
				that.playerRtc.play(that.url, that.$refs.playerRef)
			}
			// 延迟56秒之后才视频才能暂停住⏸️
			// setTimeout(() => {
			// 	that.playerRtc.pause()
			// },8000)
		},
		methods: {

		}
	}

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/demo/index.vue